// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  browserPopupRedirectResolver,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

import {
  getDatabase,
  ref,
  set,
  onValue,
  onDisconnect,
} from "firebase/database";
import EventEmitter from "./EventEmitter";
import { v4 as uuidv4 } from "uuid";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBvj2f0SkKqz56LtMK0xmEzbZo8UJMukrM",
  authDomain: "cilex-manga.firebaseapp.com",
  databaseURL: "https://cilex-manga-default-rtdb.firebaseio.com",
  projectId: "cilex-manga",
  storageBucket: "cilex-manga.appspot.com",
  messagingSenderId: "985258011400",
  appId: "1:985258011400:web:84e801aa65796021d61abd",
};

export default class FBConnection extends EventEmitter {
  constructor() {
    super();
    this.handler = {
      value: this.onFBValueChanged.bind(this),
    };

    // Initialize Firebase
    this.FIREBASE = initializeApp(FIREBASE_CONFIG);
    // init Anonymous authentification
    // const auth = getAuth(this.FIREBASE);

    // const auth = getAuth();

    const auth = initializeAuth(this.FIREBASE, {
      persistence: [
        indexedDBLocalPersistence,
        browserLocalPersistence,
        browserSessionPersistence,
      ],
    });

    onAuthStateChanged(auth, (user) => {
      if (user) {
        this._uid = user.uid;
        console.log("identified user id :", this._uid);
      } else {
        this._uid = uuidv4();
        console.log("no USER ID but : ", this._uid);
      }

      // Get database
      this.DATABASE = getDatabase();
      this.resume = false;
      this.resume2 = false;

      this.initImageListener();
      this.initJSONListener();

      const connectedRef = ref(this.DATABASE, ".info/connected");
      onValue(connectedRef, (snap) => {
        if (snap.val() === true) {
          console.log("connected");
          // if (this.uid) {
          //   this.initImageListener();
          //   this.initJSONListener();
          // }
        } else {
          console.log("not connected");
          // if (this.uid) {
          //   this.imageListener();
          //   this.jsonListener();
          // }
        }
      });
    });
    // Sign in
    signInAnonymously(auth)
      .then(() => {
        console.log("Signed in anonymously");
      })
      .catch((error) => {
        console.log(error.code, error.message);
      });

    // // Get database
    // this.DATABASE = getDatabase();
    // this.resume = false;
    // // path
    // const path = ref(this.DATABASE, `images/${this.uid}`);
    // console.log("FB LISTEN TO ", `images/${this.uid}`);
    // // EVENT
    // onValue(path, this.handler.value);
  }

  initImageListener() {
    console.log("****** INIT LISTENER");
    this.uid = `${this._uid}_${new Date().getTime()}`;
    const path = ref(this.DATABASE, `API/images/${this.uid}`);
    // EVENT
    this.imageListener = onValue(path, this.handler.value);
  }

  initJSONListener() {
    // path2
    this.uid2 = `${this._uid}_${new Date().getTime()}`;
    const path2 = ref(this.DATABASE, `API/jsons/${this.uid2}`);
    this.jsonListener = onValue(path2, this.handler.value);
  }

  onFBValueChanged(snapshot) {
    if (!this.resume) {
      // first call workaround
      this.resume = true;
    } else if (!this.resume2) {
      this.resume2 = true;
    } else {
      const val = snapshot.val();
      // -----> emmit event !
      if (val.hasOwnProperty("image")) {
        this.raiseEvent("message", [{ data: { base64: val.image } }]);
      } else {
        this.raiseEvent("message", [{ data: { json: val.data } }]);
      }
    }
  }
}
